import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"width":"26px"}
}


import { businessRoutes, businessMenu } from '@/router/modules';
import stubs from '@/init';
import lodash from 'lodash';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  props: {
  collapse: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  setup(__props) {

const props = __props


const menuMap = lodash.keyBy(
  businessMenu.map((menu) => ({ ...menu, children: [] as any[] })),
  (v) => v.key
);
businessRoutes.forEach((route) => {
  if (stubs.account.hasAllPermissions(route.meta.permissionCode)) {
    (menuMap[route.meta.parentMenuKey]?.children || []).push(route);
  }
});

const navSideConfigList = Object.values(menuMap).filter(
  (it) => it.children.length !== 0
);
navSideConfigList.sort((a, b) => a.order - b.order);

const toItem = (ite) => {
  if (ite.meta?.truePath) {
    window.open(ite.meta.truePath, '_blank');
  } else {
    router.push(ite.path);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.collapse ? 'app-sidebarActive app-sidebar' : 'app-sidebar')
  }, [
    _createVNode(_component_el_aside, {
      class: "hbb-el-aside",
      width: "auto",
      style: {"margin-top":"2rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          class: "el-menu-vertical-demo",
          "collapse-transition": true,
          collapse: props.collapse,
          "default-active": _ctx.$route.meta.parentMenuKey,
          "default-openeds": [_ctx.$route.meta.parentMenuKey]
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navSideConfigList), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_sub_menu, {
                class: _normalizeClass({
            active: item.key === _ctx.$route.meta.parentMenuKey,
          }),
                "popper-class": "hbb-left-menu-popper",
                index: item.key,
                key: item.key
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (item.icon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(["menu-icon iconfont", 'icon-' + item.icon])
                        }, null, 2))
                      : (_openBlock(), _createElementBlock("i", _hoisted_1)),
                    _withDirectives(_createElementVNode("span", null, _toDisplayString(item.title), 513), [
                      [_vShow, !props.collapse]
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (ite, inde) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: inde,
                      class: _normalizeClass({ active: _ctx.$route.meta.title === ite.meta.title }),
                      index: ite.path,
                      route: ite.path,
                      onClick: ($event: any) => (toItem(ite))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(ite.meta.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "index", "route", "onClick"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["class", "index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["collapse", "default-active", "default-openeds"])
      ]),
      _: 1
    })
  ], 2))
}
}

})